import script from "./TableImageLiveSlotegrator.vue?vue&type=script&setup=true&lang=js"
export * from "./TableImageLiveSlotegrator.vue?vue&type=script&setup=true&lang=js"

import "./TableImageLiveSlotegrator.vue?vue&type=style&index=0&id=72caa3d6&scoped=true&lang=css"
import "./TableImageLiveSlotegrator.vue?vue&type=style&index=1&id=72caa3d6&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-72caa3d6"]])

export default __exports__